import { Icon } from '@sakhtar/design-system/react';
import { SCOPE_LABELS } from '../sample.js';
import type { PartialAccess, ScopeKey } from '../types.js';

function names(keys: readonly ScopeKey[]): string {
  const labels = keys.map((key) => SCOPE_LABELS[key]);
  if (labels.length <= 1) return labels.join('');
  return `${labels.slice(0, -1).join('، ')} و ${labels[labels.length - 1] ?? ''}`;
}

/**
 * Frame F - a soft INFO notice (never a danger colour, never an error): it
 * names what the caller has no access to and what the answer is built from.
 */
export function PartialAccessNotice({ access }: { access: PartialAccess }) {
  return (
    <div className="ai-infobar" role="note">
      <span className="ai-infobar__icon" aria-hidden="true">
        <Icon name="bell" size="md" />
      </span>
      <span>
        به دادهٔ {names(access.missing)} دسترسی ندارید؛{' '}
        {access.available.length > 0
          ? `این پاسخ فقط شامل ${names(access.available)} است.`
          : 'پاسخی از آن ساخته نشد.'}
      </span>
    </div>
  );
}
